<template>
	<div style="display: flex; width: 100%">
		<div style="margin-left: auto; margin-right: 0; padding: 7px">
			<strong>{{ first + "-" + end }}</strong>
			{{ $t("of") }}
			{{ total }}
		</div>
	</div>
</template>

<script>
export default {
	name: "app-total",
	props: ["length", "total", "start", "end"],
	computed: {
		first: function () {
			return this.end > 0 ? this.start + 1 : 0
		}
	}
}
</script>
